module.exports = __webpack_public_path__ + "img/img2.ff4413fd.png";